import React, {useState } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Select, Button, Row, Col, TreeSelect } from 'antd';
import { isEmpty } from 'lodash';
import { pageUtils } from '../../../utils/common';

import GooglePicker from 'react-google-picker';
import {GOOGLE_FILEPICKER} from "../../../config/common";

const { Option } = Select;

const PageForm = props => {
    const [headerImageAlt, setHeaderImageAlt] = useState(props.headerImageAlt);
    const [headerImageSrc, setheaderImageSrc] = useState(props.headerImage);
    const { getFieldDecorator, validateFields, setFieldsValue } = props.form;
    const { onOk, onCancel, title, description, template, path, isEditing = false } = props;
    const parent = (() => {
        if (isEditing && path) {
            let parentPath = path.split('/');
            parentPath.pop();
            parentPath = parentPath.filter(part => part !== '');

            return parentPath.length > 0 ? '/' + parentPath.join('/') : undefined;
        }
        return undefined;
    })();

    /*-----------Event-driven methods-------------*/
    const handleSubmit = e => {
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                if(!values.headerImage || values.headerImage === ""){
                    values.headerImage = "";
                    values.headerImageAlt = "";
                }else{
                    values.headerImageAlt = headerImageAlt ? headerImageAlt : 'default-header-image';
                }         

                if (isEditing) {
                    values.path = (values.parentPath ? values.parentPath : '') + '/' + pageUtils.getRouteKey(values.title);
                } else {
                    values.path = values.parentPath ? values.parentPath : '';
                    delete values.parentPath;
                }

                onOk(values);
            }
        });
    };
    const handleImageChanged = e => {
        if(e.docs){
            const imgURL = GOOGLE_FILEPICKER.IMAGE_PICKER.URL_PREFIX + e.docs[0].id + GOOGLE_FILEPICKER.IMAGE_PICKER.URL_SUFFIX ;
            
            setFieldsValue({headerImage : imgURL});
            setheaderImageSrc(imgURL);
            setHeaderImageAlt(e.docs[0].name);
        }
    };
    const handleRemoveHeaderImg = e => {
        setFieldsValue({headerImage : undefined});
        setheaderImageSrc(undefined);
        setHeaderImageAlt(undefined);
    };
    /*-----------Validation methods-------------*/
    const validateTitle = (rule, value, callback) => {
        validateStringMinLength(3, value, callback);
    };
    const validateDescription = (rule, value, callback) => {
        validateStringMinLength(10, value, callback);
    };
    const validateStringMinLength = (minLength, value, callback) => {
        if (value && value.trim().length >= minLength) {
            callback();
            return;
        } else {
            callback(`Title length should be at least ${minLength} characters. (${value ? value.trim().length : 0}/${minLength})`);
        }
    };
    /*-----------Util methods-------------*/
    const createTemplatesOptions = templates => {
        return templates
            ? templates.map(template => {
                return (
                    <Option key={template} value={template}>
                        {template}
                    </Option>
                );
            })
            : [];
    };
    const convertPageToTreeData = page => {
        let treeData = {};
        if (page.path !== props.path) {
            treeData = { title: page.title, value: page.path, key: page.path, children: [] };
            if (!isEmpty(page.subpages)) {
                for (let subpage in page.subpages) {
                    let newTreeElement = convertPageToTreeData(page.subpages[subpage]);
                    if (!isEmpty(newTreeElement)) {
                        treeData.children.push(newTreeElement);
                    }
                }
            }
        }

        return treeData;
    };

    return (
        <Form layout="vertical" onSubmit={handleSubmit}>
            {headerImageSrc && headerImageSrc !== "" ? (
            <Row type="flex" justify="center">
                <Col span={8}>
                    <img src={headerImageSrc} alt={headerImageAlt} style={{ width: "100%", height: "auto" }} />
                </Col>
            </Row>
            ) : null}

            <Row type="flex" justify="space-between">
                <Col span={headerImageSrc && headerImageSrc !== ""  ? 21 : 24}>
                    <Form.Item hasFeedback label="Header image">
                        {getFieldDecorator('headerImage', { initialValue: headerImageSrc })(
                            <GooglePicker clientId={GOOGLE_FILEPICKER.GENERAL.CLIENT_ID}
                                          developerKey={GOOGLE_FILEPICKER.GENERAL.DEVELOPER_KEY}
                                          scope={GOOGLE_FILEPICKER.GENERAL.SCOPE}
                                          onAuthFailed={data => console.log('on auth failed:', data)}
                                          multiselect={false}
                                          navHidden={true}
                                          authImmediate={false}
                                          viewId={'FOLDERS'}
                                          createPicker={ (google, oauthToken) => {
                                              const googleViewId = google.picker.ViewId.DOCS;
                                              const docsView = new google.picker.DocsView(googleViewId)
                                                  .setIncludeFolders(false)
                                                  .setMimeTypes("image/png,image/jpeg,image/jpg,application/vnd.google-apps.folder")
                                                  .setParent(GOOGLE_FILEPICKER.IMAGE_PICKER.FODLER_ID)
                                                  .setEnableDrives(true)
                                                  .setSelectFolderEnabled(false);

                                              const picker = new window.google.picker.PickerBuilder()
                                                  .addView(docsView)
                                                  .setOAuthToken(oauthToken)
                                                  .setDeveloperKey(GOOGLE_FILEPICKER.GENERAL.DEVELOPER_KEY)
                                                  .enableFeature(google.picker.Feature.SUPPORT_DRIVES)
                                                  .enableFeature(google.picker.Feature.NAV_HIDDEN)
                                                  .setCallback((e)=>{
                                                        if(e.action === "picked"){
                                                            handleImageChanged(e);
                                                        }
                                                  });

                                              picker.build().setVisible(true);
                                          }}>
                                <Button type="dashed" icon="setting" style={{ marginRight: '1rem', width: '100%' }} >
                                    Select from Drive
                                </Button>
                            </GooglePicker>
                        )}
                    </Form.Item>
                </Col>
                {headerImageSrc ? (
                <Col span={2}>
                    <Button type="danger" onClick={handleRemoveHeaderImg} icon="delete" title="Remove header image"  style={{ marginTop: '1.8rem' }}/>
                </Col>                            
                ) : null}   
            </Row>
            <Row type="flex" justify="start">
                <Col span={24}>
                    <Form.Item label="Title" required hasFeedback>
                        {getFieldDecorator('title', {
                            rules: [
                                {
                                    validator: validateTitle
                                }
                            ],
                            initialValue: title
                        })(<Input name="title" placeholder="Page title" />)}
                    </Form.Item>
                </Col>
            </Row>
            <Row type="flex" justify="start">
                <Col span={24}>
                    <Form.Item label="Description" required hasFeedback>
                        {getFieldDecorator('description', {
                            rules: [
                                {
                                    validator: validateDescription
                                }
                            ],
                            initialValue: description
                        })(<Input.TextArea name="description" placeholder="Page description" rows={4} />)}
                    </Form.Item>
                </Col>
            </Row>
            <Row type="flex" justify="space-between">
                <Col span={11}>
                    <Form.Item label="Template" required hasFeedback={!isEditing}>
                        {getFieldDecorator('template', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Please select a template'
                                }
                            ],
                            initialValue: template
                        })(
                            <Select name="template" placeholder="Select the page template" showSearch disabled={isEditing}>
                                {createTemplatesOptions(props.templates)}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col span={11}>
                    <Form.Item label="Parent page" hasFeedback>
                        {getFieldDecorator('parentPath', { initialValue: parent })(
                            <TreeSelect
                                name="parentPath"
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                treeData={props.pages.map(convertPageToTreeData).filter(o => !isEmpty(o))}
                                placeholder="Select the parent page"
                                treeDefaultExpandAll
                                allowClear={true}
                            />
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Row type="flex" justify="space-between">
                <Form.Item>
                    <Button type="danger" icon="close-circle" onClick={onCancel} style={{ marginRight: '1rem' }}>
                        Cancel
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" icon="check-circle" htmlType="submit">
                        {isEditing ? 'Confirm' : 'Create'}
                    </Button>
                </Form.Item>
            </Row>
        </Form>
    );
};

const mapStateToProps = state => ({
    templates: state.templates.templates,
    pages: state.pages.pages
});

export default connect(
    mapStateToProps,
    null
)(Form.create({ name: 'customized_form_controls' })(PageForm));
